import {
  takeEvery,
  call,
  put,
  all,
  select,
  takeLeading,
} from "redux-saga/effects";
import {
  LOAD_PLAYLIST,
  loading,
  putPlaylists,
  putPlaylist,
  updatePlaylist,
  updatePlaylistsSongs,
} from "../../store/ContentPlaylists/actions";
import { showAlertError } from "../../store/Alert/actions";
import axios from "axios";
import { buildGETUrl } from "../../utilities/buildGETUrl";
import { changeValue } from "../../store/Search/actions";
import { loadAssocPublicTracks } from "../../store/PublicPlaylists/actions";
import { parseDate } from "../../utilities/parseDate";

export default function* () {
  yield takeLeading(LOAD_PLAYLIST, worker);
}

function* worker({ payload }) {
  // yield put(loading(true))
  //console.log(payload)
  // const selectedPlaylists = yield select(state => state.playlists.allPlaylists.filter(playlist => payload.includes(playlist.id)));
  if (!payload.length) return;

  yield put(changeValue({ type: "songs", value: "" }));

  const playlists = yield select((state) => state.playlists.allPlaylists);

  const result = [];
  for (const selectedPlaylist of payload) {
    // if (typeof selectedPlaylist.songs !== "undefined") {
    //yield put(updatePlaylist({playlist: selectedPlaylist}));
    // continue;
    // }
    if (
      !selectedPlaylist ||
      playlists.find((el) => el.id === selectedPlaylist)?.songs?.length
    ) {
      return;
    }

    try {
      const fetchedPlaylist = yield call(fetchSongs, selectedPlaylist);

      if (fetchedPlaylist.error) {
        yield put(
          showAlertError({
            errors: [`Ошибка сервера при ${LOAD_PLAYLIST}.`, fetchedPlaylist],
            text: "Треки не были загружены. Попробуйте перезагрузить страницу.",
          })
        );
        //yield put(putPlaylists({playlists}))
      } else {
        const fpl = fetchedPlaylist.success;

        const songs = Object.values(fpl.songs)
          .reverse()
          .map((song) => ({
            ...song,
            filename: buildGETUrl("clip/play", { id: song.id }),
            clipsecs: parseCliptime(song.cliptime),
            ...parseDate(song.ctime),            
          }));

        console.log({ fpl, songs });

        result.push({
          ...fpl,
          songs, // теперь массив
        });
      }
    } catch (e) {
      yield put(
        showAlertError({
          errors: [`Ошибка сети при ${LOAD_PLAYLIST}.`, e],
          text: "Треки не были загружены. Попробуйте перезагрузить страницу.",
        })
      );
      //yield put(putPlaylists({playlists: []}))
    } finally {
      // yield put(loading(false))
    }
  }

  yield put(updatePlaylistsSongs(result));
}

export function fetchSongs(playlistId) {
  return axios
    .get("/playlist/get", {
      params: {
        id: playlistId,
        //  'sort[turn]': 'DESC' 
      },

    })
    .then((response) => response.data);
}


const parseCliptime = (time) => {
  if (!time) return 0;

  const [h, m, s] = time.split(":");
  return (
    Number(h) * 3600 +
    Number(m) * 60 +
    parseFloat(s.replace(",", "."))
  );
};
